<template>
  <oie-interactive-list-item class="machine-item">
    <template #media>
      <oie-base-action
        v-if="showFavourite"
        v-tooltip.top="tStatic('favoriteMachine')"
        class="machine-item__favourite"
        theme="flat"
        @click.stop="toggleFavouriteMachine(machine.machineId)">
        <oie-base-icon :icon="machine.favourite ? 'starFilled' : 'star'" size="l"></oie-base-icon>
      </oie-base-action>
      <img
        v-if="profileImageUrl"
        :src="`${profileImageUrl}?preset=ProductThumb`"
        :alt-text="machine.name">
      <oie-base-icon v-else icon="machine" size="l"></oie-base-icon>
    </template>
    <template #content>
      <button class="h3 machine-item__name" @click.stop="$emit('select-machine', machine)">
        {{ machine.name }}
      </button>
      <p class="body-smaller machine-item__details">
        {{ getNodeHierarchyNames(machine) }}
      </p>
    </template>
    <template v-if="hasActions" #actions>
      <slot name="actions"></slot>
    </template>
  </oie-interactive-list-item>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import { getNodeHierarchyNames } from '@/core/my-machines-service'

export default {
  props: {
    machine: {
      type: Object,
      required: true
    },
    showFavourite: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('myMachines', ['vehicleIdDictionary']),
    profileImageUrl() {
      const profileImage = _.find(this.machine.images, img => img.type === 'profile')
      return profileImage && profileImage.url
    },
    hasActions() {
      return this.$slots.actions || this.$scopedSlots.actions
    }
  },
  methods: {
    ...mapActions('myMachines', ['toggleFavouriteMachine', 'updateMachinesForOwner', 'getVehicleNamesFromHierarchy']),
    toggleFavorite(machineId) {
      this.toggleFavouriteMachine(machineId)
    },
    getNodeHierarchyNames: getNodeHierarchyNames
  }
}

</script>

<style lang="scss">
.machine-item:hover {
  background-color: color(blue-5);

  .machine-item__name {
    text-decoration: underline;
  }
}
.machine-item {
  .interactive-list-item__media {
    width: unset;
  }
}

.machine-item__name {
  @include reset-button;
}

.machine-item__name::after {
  content: "";
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
}

.machine-item__favourite {
  z-index: 1;
  margin-inline-end: measure(eighth);
  color: color(gray-1)
}

.machine-item__details {
  color: color(gray-2);
  display: flex;
  align-items: center;
}

</style>
